import he from 'he';
import Head from 'next/head';
import React from 'react';

interface IHeadMetaProps {
  slug?: string | null;
  title: string;
}

const HeadMeta: React.FC<IHeadMetaProps> = ({ title, slug }) => {
  return (
    <Head>
      <title>{title ? `${he.decode(title)} | Outdoorsy` : 'Outdoorsy'}</title>
      <link rel="canonical" href={`https://www.outdoorsy.com/help/${slug ? slug : ''}`} />
      <meta name="description" content={title} />
      <meta property="fb:app_id" content="604465049688341" />
      <meta name="msvalidate.01" content="1DD3784B3E7F8CD7B4C595940717F938" />
      <meta name="apple-itunes-app" content="app-id=1443835927, affiliate-data=1010lvba" />
      <meta name="google-site-verification" content="DuUf3p3Pr3-gmZfpMIg3gyG75gl7C3JpXWb0-ilQJbI" />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <meta
        name="googlebot"
        content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
      />
      <meta
        name="bingbot"
        content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={`${title} | Outdoorsy.com`} />
      <meta property="og:site_name" content="Outdoorsy Help" />
      <meta property="og:description" content={title} />
      <meta name="twitter:card" content="summary" />
    </Head>
  );
};

export default HeadMeta;
